import { useQuery } from '@tanstack/react-query'
import { URLS } from '../../../infra/URLS'
import { getBotijaoModulo, getBotijoes } from '../queries/getBotijao'

export function useGetBotijoes(search?: string, page = 1) {
  const resultQuery = useQuery(
    [`${URLS.BOTIJAO_API}`, {
      params: { search, page }
    }],
    () => getBotijoes(search, page)
  );

  return resultQuery;
}

export function useGetBotijao(BotijaoId : number) {
  const resultQuery = useQuery(
    [`${URLS.BOTIJAO_API}/${BotijaoId}`],
    () => getBotijaoModulo(BotijaoId)
  )

  return resultQuery;
}
